import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-maintenance",
  "use": "icon-maintenance-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-maintenance\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.95 4.05A7 7 0 1 1 2.84 5.67l4.038 4.037a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414L5.67 2.84a7.003 7.003 0 0 1 8.28 1.21Zm4.95 17.678-5.168-5.168a8.948 8.948 0 0 0 2.828-2.829l5.168 5.168a1 1 0 0 1 0 1.415l-1.414 1.414a1 1 0 0 1-1.415 0Z\" fill=\"#A4B4D0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol